export const baseUrlApi = process.env.REACT_APP_API_URL;
